import { Injectable } from "@angular/core";

import { BaseService } from "../abstracts/base.service";
import { ResultModel } from "../models/result.model";
import { LessonModel } from '../models/lesson.model';
import { ClassModel } from '../models/class.model';
import { SubjectModel } from '../models/subject.model';
import { QuestionModel } from '../models/question.model';
import { QuestionMessageModel } from '../models/question-message.model';
import { InstructorModel } from '../models/instructor.model';
import { VirtualClassModel } from '../models/virtual-class.model';
import { AppointmentModel } from '../models/appointment';

@Injectable({
  providedIn: "root",
})
export class InstructorUserService extends BaseService {

  getCurrentInstructor() {
    return this.httpClient.get<{ Success: boolean, Message: string, Instructor: InstructorModel }>(this.getApiUrl("instructor"));
  }

  listAllClassLessons(classID: string) {
    return this.httpClient.get<ResultModel<LessonModel[]>>(this.getApiUrl(`instructor/classes/${classID}/lessons`));
  }

  listAllClassesForDataTable(formData: FormData) {
    return this.httpClient.post<ResultModel<any[]>>(this.getApiUrl("instructor/classes"), formData);
  }

  createOnlineLecture(classID: string, virtualClass: VirtualClassModel) {
    return this.httpClient.post<ResultModel<VirtualClassModel>>(this.getApiUrl(`instructor/classes/${classID}/online-lectures/add`), virtualClass);
  }

  listClassOnlineLecturesForDataTable(classID: string, formData: FormData) {
    return this.httpClient.post<ResultModel<any[]>>(this.getApiUrl(`instructor/classes/${classID}/online-lectures`), formData);
  }

  listLessonSubjects(classLesson: { classID: ClassModel, lessonID: LessonModel }) {
    return this.httpClient.get<ResultModel<SubjectModel[]>>(this.getApiUrl(`instructor/classes/${classLesson.classID}/lessons/${classLesson.lessonID}/subjects`));
  }

  listLessonSubjectsForDataTable(formData: FormData, classLesson: { classID: ClassModel, lessonID: LessonModel }) {
    return this.httpClient.post<ResultModel<SubjectModel[]>>(this.getApiUrl(`instructor/classes/${classLesson.classID}/lessons/${classLesson.lessonID}/subjects`), formData);
  }

}
